import React, {
  createContext,
  useState,
  useMemo,
  useContext, useRef,
} from 'react';

type BoomiContextType = {
  isDarkMode: boolean;
  setIsDarkMode: React.Dispatch<React.SetStateAction<boolean>>;
  initialUserPrompt: string;
  setInitialUserPrompt: any;
  isLoading: boolean;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  disabled: boolean;
  setDisabled: React.Dispatch<React.SetStateAction<boolean>>;
  isAuthorized: boolean;
  setIsAuthorized: React.Dispatch<React.SetStateAction<boolean>>;
  isError: boolean;
  setIsError: React.Dispatch<React.SetStateAction<boolean>>;
  placeHolderType: string;
  setPlaceHolderType: React.Dispatch<React.SetStateAction<string>>;
  processId: any;
  setProcessId: React.Dispatch<React.SetStateAction<any>>;
  userName: string;
  setUserName: React.Dispatch<React.SetStateAction<string>>;
  conversation: any;
  setConversation: React.Dispatch<React.SetStateAction<any>>;
  conversationId: string;
  setConversationId: React.Dispatch<React.SetStateAction<string>>;
  showConversationPage: boolean;
  setShowConversationPage: React.Dispatch<React.SetStateAction<boolean>>;
  isEmbedded: boolean;
  setIsEmbedded: React.Dispatch<React.SetStateAction<boolean>>;
  inputText: string,
  setInputText: React.Dispatch<React.SetStateAction<string>>;
  attachedProcess: any,
  setAttachedProcess: React.Dispatch<React.SetStateAction<any>>;
  methodResponse: any;
};

const BoomiContext = createContext<BoomiContextType | undefined>(undefined);

function BoomiContextProvider(props: { children: any }) {
  const { children } = props;
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [initialUserPrompt, setInitialUserPrompt] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [isAuthorized, setIsAuthorized] = useState(true);
  const [isError, setIsError] = useState(false);
  const [placeHolderType, setPlaceHolderType] = useState<string>('');
  const [processId, setProcessId] = useState<any>();
  const [userName, setUserName] = useState<string>('');
  const [conversation, setConversation] = useState<any>([]);
  const [conversationId, setConversationId] = useState<string>('');
  const [showConversationPage, setShowConversationPage] = useState(false);
  const [isEmbedded, setIsEmbedded] = useState(false);
  const [inputText, setInputText] = useState('');
  const [attachedProcess, setAttachedProcess] = useState<any>();
  const methodResponse = useRef<any>('');

  const value = useMemo(
    () => ({
      isDarkMode,
      setIsDarkMode,
      initialUserPrompt,
      setInitialUserPrompt,
      isLoading,
      setIsLoading,
      disabled,
      setDisabled,
      isAuthorized,
      setIsAuthorized,
      isError,
      setIsError,
      placeHolderType,
      setPlaceHolderType,
      processId,
      setProcessId,
      userName,
      setUserName,
      conversation,
      setConversation,
      conversationId,
      setConversationId,
      showConversationPage,
      setShowConversationPage,
      isEmbedded,
      setIsEmbedded,
      methodResponse,
      inputText,
      setInputText,
      attachedProcess,
      setAttachedProcess,
    }),
    [
      isDarkMode,
      initialUserPrompt,
      isLoading,
      disabled,
      isAuthorized,
      isError,
      placeHolderType,
      processId,
      userName,
      conversation,
      conversationId,
      showConversationPage,
      isEmbedded,
      methodResponse,
      inputText,
      attachedProcess,
    ],
  );

  return <BoomiContext.Provider value={value}>{children}</BoomiContext.Provider>;
}

export const useBoomiContext = () => {
  const context = useContext(BoomiContext);
  if (!context) {
    throw new Error('useMyContext must be used within a MyContextProvider');
  }
  return context;
};

export default BoomiContextProvider;
